module.exports = __webpack_public_path__ + "static/img/section_06_bg_mo.54ba89d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/PR010105/section_06_bg_mo.png
// module id = Q9Uv
// module chunks = 10